// extracted by mini-css-extract-plugin
module.exports = {"Breadcrumbs":"Breadcrumbs_Breadcrumbs__3YILa"};